/** Extra bottom space on native bottom sheets (above home indicator). */
export const nativeSheetBottomPad =
  "pb-[calc(12px+env(safe-area-inset-bottom,0px))]";

/** Padding at end of scrollable sheet body content. */
export const nativeSheetScrollBottomPad = "pb-3";
